import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { AND, MOD, ROUNDDOWN, XIF, INT, ROUNDUP } from '../utils/excel-functions-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from './ter-protobomp-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { terUtilsNumberRoundUp } from './ter-utils';
import { _novo_tabela_za_ramfiltera_get_item } from './ter-novo';
import { _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje } from './ter-derivat-lib-terkk-uni-dimenzije';


/*
TODO


*/


export const derDraftel_terkk_ramfiltera_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // draftel_codecs_pack_terkk$_bundle_ramfiltera.default_pods_input_state(),
    tipkomore: virtel_k.tipkomore,
    vrstaprofila: virtel_m.vrstaprofila,
    // msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjupregradnih: virtel_m.mvisinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjukrilaca: virtel_m.mvisinaunutrasnjaizmedjukrilaca,
    //
    // ksirinaoznaka: virtel_k.ksirinaoznaka,
    // kvisinaoznaka: virtel_k.kvisinaoznaka,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_rfi_izracunaj_materijale = (pods_input, cparams_combined, state) => {
  //
  const tipkomore = pods_input.tipkomore;
  const rfi_tipfiltera = state.rfi_tipfiltera;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro" || rfi_tipfiltera === "HEPA_25" || rfi_tipfiltera === "HEPA_292") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let rfi_materijal_lim_tanji = null;
  let rfi_materijal_lim_deblji = null;
  if (tipmetalalima === "pocinkovani") {
    rfi_materijal_lim_tanji = _cpci.rfi_materijal_lim_pocinkovani_tanji;
    rfi_materijal_lim_deblji = _cpci.rfi_materijal_lim_pocinkovani_deblji;
  }
  if (tipmetalalima === "prohrom") {
    rfi_materijal_lim_tanji = _cpci.rfi_materijal_lim_prohrom_tanji;
    rfi_materijal_lim_deblji = _cpci.rfi_materijal_lim_prohrom_deblji;
  }
  //
  return {
    tipmetalalima,
    rfi_materijal_lim_tanji,
    rfi_materijal_lim_deblji,
  };
};


//
export const _derivat_terkk_ramfiltera_izracunaj_ramove = (state, pods_input) => {
  //
  const {
    // msirinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjukrilaca,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    vrstaprofila,
    msirinaspoljasnja,
    mvisinaspoljasnja,
  } = pods_input;
  const {
    rfi_tipfiltera,
    tervrstaprofila_50_ili_70,
  } = state;
  //
  const {
    unutrasnjaIzmedjuPregradnih: msirinaunutrasnjaizmedjupregradnih, // preimenujemo  u msirinaunutrasnjaizmedjupregradnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(msirinaspoljasnja, vrstaprofila);
  const {
    unutrasnjaIzmedjuKrilaca: mvisinaunutrasnjaizmedjukrilaca, // preimenujemo  u mvisinaunutrasnjaizmedjukrilaca
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(mvisinaspoljasnja, vrstaprofila);
  //

  // 2.
  let rfi_koliko_ram610x610 = 0;
  if (rfi_tipfiltera === "CARBON") {
    rfi_koliko_ram610x610 = 0;
  } else {
    rfi_koliko_ram610x610 = ROUNDDOWN(msirinaunutrasnjaizmedjupregradnih / 610, 0) * ROUNDDOWN(mvisinaunutrasnjaizmedjukrilaca / 610, 0);
  }

  // 3.
  // Formula u excelu nam izgleda ovako:
  // =IF(F8="CARBON";0;IF(I8=370;ROUNDDOWN(H8/610;0);IF(I8>609;IF(INT($I$6)=$I$6;0;ROUNDDOWN(I8/610;0))+IF(INT($J$6)=$J$6;0;ROUNDDOWN(H8/610;0));0)))
  const C8 = "12"; // TODO
  const D8 = "06"; // TODO
  const E8 = Number.parseInt(tervrstaprofila_50_ili_70); // FIX
  // G8 Širina komore [mm] - tačna veličina
  // const G8 = 1220; // TODO
  // const G8 = mvisinaunutrasnjaizmedjukrilaca; // G8 to je broj modula i nigde se ne koristi
  // H8 Visina komore [mm] - tačna veličina
  // const H8 = 610; // TODO
  // 2024-12-17
  const F8 = rfi_tipfiltera;
  const H8 = msirinaunutrasnjaizmedjupregradnih; // tacno
  const I8 = mvisinaunutrasnjaizmedjukrilaca;
  const I6 = H8 / 610;
  const J6 = I8 / 610;
  const rfi_koliko_ram305x610 = XIF(F8 === "CARBON", 0, XIF(I8 === 370, ROUNDDOWN(H8 / 610, 0), XIF(I8 > 609, XIF(INT(I6) === I6, 0, ROUNDDOWN(I8 / 610, 0)) + XIF(INT(J6) === J6, 0, ROUNDDOWN(H8 / 610, 0)), 0)));

  // 4.
  let rfi_koliko_ram510x610 = 0;
  if (rfi_tipfiltera === "CARBON") {
    rfi_koliko_ram510x610 = 0;
  } else {
    if (mvisinaunutrasnjaizmedjukrilaca === 510) {
      rfi_koliko_ram510x610 = ROUNDDOWN(mvisinaunutrasnjaizmedjukrilaca / 610, 0);
    } else {
      rfi_koliko_ram510x610 = 0;
    }
  }

  // 5.
  let rfi_koliko_ram510x305 = 0;
  if (rfi_tipfiltera === "CARBON") {
    rfi_koliko_ram510x305 = 0;
  } else {
    if (mvisinaunutrasnjaizmedjukrilaca === 510 && msirinaunutrasnjaizmedjupregradnih === 915) {
      rfi_koliko_ram510x305 = 1;
    } else {
      rfi_koliko_ram510x305 = 0;
    }
  }

  // 6. Maska 305x305
  // Formula za proračun maska 305x305:
  // =IF(AND(MOD($mvisinaunutrasnjaizmedjukrilaca/610;1)=0,5; MOD($msirinaunutrasnjaizmedjupregradnih;1)=0,5); 1; 0)
  // Ispravna formula za maske
  // =IF(AND(MOD($mvisinaunutrasnjaizmedjukrilaca/610;1)=0,5; MOD($msirinaunutrasnjaizmedjupregradnih/610;1)=0,5); 1; 0)
  const rfi_koliko_maska305x305 = XIF(AND(MOD(mvisinaunutrasnjaizmedjukrilaca / 610, 1) === 0.5, MOD(msirinaunutrasnjaizmedjupregradnih / 610, 1) === 0.5), 1, 0);
  // TODO ovo zakomentarisati nakon testiranja
  console.log('mvisinaunutrasnjaizmedjukrilaca', mvisinaunutrasnjaizmedjukrilaca);
  console.log('msirinaunutrasnjaizmedjupregradnih', msirinaunutrasnjaizmedjupregradnih);
  console.log('MOD(mvisinaunutrasnjaizmedjukrilaca / 610, 1)', MOD(mvisinaunutrasnjaizmedjukrilaca / 610, 1));
  console.log('MOD(msirinaunutrasnjaizmedjupregradnih / 610, 1)', MOD(msirinaunutrasnjaizmedjupregradnih / 610, 1));
  console.log('rfi_koliko_maska305x305', rfi_koliko_maska305x305);

  //
  return {
    rfi_koliko_ram610x610,
    rfi_koliko_ram305x610,
    rfi_koliko_ram510x610,
    rfi_koliko_ram510x305,
    rfi_koliko_maska305x305,
  };
};


//
const OLD_derivat_terkk_ramfiltera_izracunaj_ramove = (state, pods_input) => {
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
  } = pods_input;
  const {
    rfi_tipfiltera, ksirinaoznaka, kvisinaoznaka, tervrstaprofila_50_ili_70,
  } = state;
  //

  const C8 = "12"; // TODO
  const D8 = "06"; // TODO
  const E8 = Number.parseInt(tervrstaprofila_50_ili_70); // FIX
  const F8 = rfi_tipfiltera;
  // G8 Širina komore [mm] - tačna veličina
  const G8 = 1220; // TODO
  // H8 Visina komore [mm] - tačna veličina
  const H8 = 610; // TODO

  const I6 = H8 / 610;
  const H6 = G8 / 610;

  // U zavisnosti od Širine i Visine komore izračunava se broj komada tih ramova:

  // Ram 610x610 [kom]: =ROUNDDOWN(G8/610,0)*ROUNDDOWN(H8/610,0)
  const rfi_koliko_ram610x610 = ROUNDDOWN(G8 / 610, 0) * ROUNDDOWN(H8 / 610, 0);

  // Ram 305x610 [kom]: =IF(H8=370,ROUNDDOWN(G8/610,0),IF(H8>609,IF(INT($H$6)=$H$6,0,ROUNDDOWN(H8/610,0))+IF(INT($I$6)=$I$6,0,ROUNDDOWN(G8/610,0)),0))
  const rfi_koliko_ram305x610 = XIF(H8 === 370, ROUNDDOWN(G8 / 610, 0), XIF(H8 > 609, XIF(INT(H6) === H6, 0, ROUNDDOWN(H8 / 610, 0)) + XIF(INT(I6) === I6, 0, ROUNDDOWN(G8 / 610, 0)), 0));

  // Ram 510x610 [kom]: =IF(D8="05",ROUNDDOWN(G8/610,0),0)
  const rfi_koliko_ram510x610 = XIF(D8 === "05", ROUNDDOWN(G8 / 610, 0), 0);

  // Ram 510x305 [kom]: =IF(AND(H8=510,G8=915),1,0)
  const rfi_koliko_ram510x305 = XIF(AND(H8 === 510, G8 === 915), 1, 0);

  /* Broj Crteža Rama: =IF(F8="VRECASTI FILTER 25mm","P01-15-B",
  IF(F8="PANELNI FILTER 45mm","P01-15-B",
  IF(F8="STANDARD 25+45mm","P01-15-B",
  IF(F8="HEPA 25mm","P01-15-A",
  IF(F8="HEPA 292mm","P01-15-C",
  "")))))
  */
  const rfi_broj_crteza_rama = XIF(F8 === "VRECASTI_25", "P01-15-B",
    XIF(F8 === "PANELNI_45", "P01-15-B",
      XIF(F8 === "DUPLI_24_45", "P01-15-B",
        XIF(F8 === "HEPA_25", "P01-15-A",
          XIF(F8 === "HEPA_292", "P01-15-C",
            "")))));

  /* Broj Crteža Nosač Rama: =IF(F8<>"","P01-15-"&
  IF(F8="VRECASTI FILTER 25mm","F75",
  IF(F8="PANELNI FILTER 45mm","F100",
  IF(F8="STANDARD 25+45mm","F125",
  IF(F8="HEPA 25mm","F82",
  IF(F8="HEPA 292mm","F150","?"))))),"")
  &IF(E8=50,"-H20",
  IF(E8=70,"-H35",""))
  &"-"&C8
  */
  const rfi_broj_crteza_nosaca_rama = XIF(F8 !== "", "P01-15-" +
    XIF(F8 === "VRECASTI_25", "F75",
      XIF(F8 === "PANELNI_45", "F100",
        XIF(F8 === "DUPLI_24_45", "F125",
          XIF(F8 === "HEPA_25", "F82",
            XIF(F8 === "HEPA_292", "F150", "?"))))), "")
    + XIF(E8 === 50, "-H20",
      XIF(E8 === 70, "-H35", "")) + "-" + C8;

  // Broj Komada je uvek 2
  const broj_komada = 2;

  //
  return {
    rfi_koliko_ram610x610,
    rfi_koliko_ram305x610,
    rfi_koliko_ram510x610,
    rfi_koliko_ram510x305,
    rfi_broj_crteza_rama,
    rfi_broj_crteza_nosaca_rama,
    kolicina: broj_komada,
  };
};


//
export const _derivat_terkk_ramfiltera_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
    tervrstaprofila_50_ili_70,
    rfi_tipfiltera,
    //
    rfi_materijal_lim_tanji,
    rfi_materijal_lim_deblji,
    //
    kolicina,
  } = protobomp_superdata;
  //

  //
  if (tervrstaprofila_50_ili_70 === "50") {
    _visina_20_ili_35 = 20;
  }
  if (tervrstaprofila_50_ili_70 === "70") {
    _visina_20_ili_35 = 35;
  }
  //
  const _izracunaj_razvijena2 = (rfi_tipfiltera, tervrstaprofila_50_ili_70) => {
    if (tervrstaprofila_50_ili_70 === "50") {
      /*
      VRECASTI FILTER 25mm	P50	105.7
      PANELNI FILTER 45mm	P50	130.7
      DUPLI FILTER 24+45mm	P50	155.7
      HEPA 25mm	P50	112.7
      HEPA 292mm	P50	180.7
      CARBON	P50	180.7
      */
      if (rfi_tipfiltera === "VRECASTI_25") {
        return 105.7;
      } else if (rfi_tipfiltera === "PANELNI_45") {
        return 130.7;
      } else if (rfi_tipfiltera === "DUPLI_24_45") {
        return 155.7;
      } else if (rfi_tipfiltera === "HEPA_25") {
        return 112.7;
      } else if (rfi_tipfiltera === "HEPA_292") {
        return 180.7;
      } else if (rfi_tipfiltera === "CARBON") {
        return 180.7;
      }
    } else if (tervrstaprofila_50_ili_70 === "70") {
      /*
      VRECASTI FILTER 25mm	P70	136
      PANELNI FILTER 45mm	P70	160.7
      DUPLI FILTER 24+45mm	P70	185.7
      HEPA 25mm	P70	142.7
      HEPA 292mm	P70	210.7
      CARBON	P70	210.7
      */
      if (rfi_tipfiltera === "VRECASTI_25") {
        return 136;
      } else if (rfi_tipfiltera === "PANELNI_45") {
        return 160.7;
      } else if (rfi_tipfiltera === "DUPLI_24_45") {
        return 185.7;
      } else if (rfi_tipfiltera === "HEPA_25") {
        return 142.7;
      } else if (rfi_tipfiltera === "HEPA_292") {
        return 210.7;
      } else if (rfi_tipfiltera === "CARBON") {
        return 210.7;
      }
    }
    return '?';
  };
  //
  const _izracunaj_dimenzija2 = (rfi_tipfiltera) => {
    /*
    VRECASTI FILTER 25mm	75
    PANELNI FILTER 45mm	100
    DUPLI FILTER 24+45mm	125
    HEPA 25mm	82
    HEPA 292mm	150
    CARBON	75
    */
    if (rfi_tipfiltera === "VRECASTI_25") {
      return 75;
    } else if (rfi_tipfiltera === "PANELNI_45") {
      return 100;
    } else if (rfi_tipfiltera === "DUPLI_24_45") {
      return 125;
    } else if (rfi_tipfiltera === "HEPA_25") {
      return 82;
    } else if (rfi_tipfiltera === "HEPA_292") {
      return 150;
    } else if (rfi_tipfiltera === "CARBON") {
      return 75;
    }
    return '?';
  };
  //

  //
  if (true) {
    // sklop // NJ: Ovde nemamo sklop za elemente. Svaki element ide zasebno kao i materijal.
    /*
    if (family === 'terkk$rfi/SKLOP_RFI') { // NJ: Ovde nemamo sklop za elemente. Svaki element ide zasebno kao i materijal.
      // item.distinction_key = "terkk$RFI/SKLOP_RFI"; // DIRTY
    }
    */
    //
    if (family === 'terkk$rfi/NOSAC_SPOLJ') { // P1 1. odnosi se na spoljašnji profil nosača filtera.
      /*
      Naziv: "NOSAC RAMA FILTERA - "$msirinaunutrasnjaizmedjupregradnih-2"X" IF($rfi_tipfiltera="VREĆASTI FILTER 25mm" THEN "75" ELSE $rfi_tipfiltera="PANELNI FILTER 45mm" THEN "100" ELSE $rfi_tipfiltera="DUPLI FILTER 24+45mm" THEN "125" ELSE $rfi_tipfiltera="HEPA 25mm" THEN "82" ELSE $rfi_tipfiltera="HEPA 292mm" THEN "150" ELSE $rfi_tipfiltera="CARBON" THEN "75" ELSE "?""-"IF($tervrstaprofila_50_ili_70=50 THEN "P50" ELSE IF($tervrstaprofila_50_ili_70=70 THEN "P70"))"-SPOLJASNJI PROFIL NOSACA"
      IF petlja u tablici:

      Broj komada: IF($msirinaunutrasnjaizmedjupregradnih<2500 THEN 2 ELSE IF($msirinaunutrasnjaizmedjupregradnih>=2500 THEN 4

      Dim1: IF($msirinaunutrasnjaizmedjupregradnih<2500 THEN $msirinaunutrasnjaizmedjupregradnih-2 ELSE IF($msirinaunutrasnjaizmedjupregradnih>=2500 THEN $msirinaunutrasnjaizmedjupregradnih/2 Zaokruživanje na nižu cifru sa 0 decimala

      Dim2: IF($rfi_tipfiltera="VREĆASTI FILTER 25mm" THEN "75" ELSE $rfi_tipfiltera="PANELNI FILTER 45mm" THEN "100" ELSE $rfi_tipfiltera="DUPLI FILTER 24+45mm" THEN "125" ELSE $rfi_tipfiltera="HEPA 25mm" THEN "82" ELSE $rfi_tipfiltera="HEPA 292mm" THEN "150" ELSE $rfi_tipfiltera="CARBON" THEN "75" ELSE "?"

      IF($msirinaunutrasnjaizmedjupregradnih<2500 THEN $msirinaunutrasnjaizmedjupregradnih-2 ELSE IF($msirinaunutrasnjaizmedjupregradnih>=2500 THEN $msirinaunutrasnjaizmedjupregradnih/2 *Zaokruživanje na nižu cifru sa 0 decimala
      */
      item.distinction_key = "terkk$RFI/P1"; // DIRTY
      // item.tip = "1"; // DIRTY
      _naziv = "NOSAC RAMA FILTERA -" + (msirinaunutrasnjaizmedjupregradnih - 2) + "x" + _izracunaj_dimenzija2(rfi_tipfiltera) + "-SPOLJASNJI PROFIL NOSACA"; //
      if (msirinaunutrasnjaizmedjupregradnih < 2500) {
        item.ter_visedelni_koliko_delova = 1; // DIRTY
        item.kolicina = kolicina * 2; // DIRTY
        item.dimenzija1 = msirinaunutrasnjaizmedjupregradnih - 2; // DIRTY
      } else {
        item.kolicina = kolicina * 4; // DIRTY
        item.ter_visedelni_koliko_delova = 2; // DIRTY
        item.dimenzija1 = ROUNDDOWN(msirinaunutrasnjaizmedjupregradnih / 2, 0); // DIRTY
      }
      item.dimenzija2 = _izracunaj_dimenzija2(rfi_tipfiltera); // DIRTY
      item.razvijenamera1 = item.dimenzija1;
      item.razvijenamera2 = _izracunaj_razvijena2(rfi_tipfiltera, tervrstaprofila_50_ili_70); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = rfi_materijal_lim_tanji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      /*
      CNC crtez:
      P01-15-F75-H35-2438-P1 (PRIMER)
      "P01-15-"IF($rfi_tipfiltera="VREĆASTI FILTER 25mm" THEN "75" ELSE $rfi_tipfiltera="PANELNI FILTER 45mm" THEN "100" ELSE $rfi_tipfiltera="DUPLI FILTER 24+45mm" THEN "125" ELSE $rfi_tipfiltera="HEPA 25mm" THEN "82" ELSE $rfi_tipfiltera="HEPA 292mm" THEN "150" ELSE $rfi_tipfiltera="CARBON" THEN "75" ELSE "?"-IF(tervrstaprofila_50_ili_70=50 THEN H20 ELSE IF(tervrstaprofila_50_ili_70=70 THEN H35"-"$msirinaunutrasnjaizmedjupregradnih-2"-P1"
      */
      _cnc = "P01-15-" + _izracunaj_dimenzija2(rfi_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + (msirinaunutrasnjaizmedjupregradnih - 2) + "-P1";
      //
      item.visina = _visina_20_ili_35; // DIRTY
    }
    //
    if (family === 'terkk$rfi/NOSAC_UNUTR') { // P2 2. Odnosi se na unutrašnji profil nosača filtera.
      /*
      */
      item.distinction_key = "terkk$RFI/P2"; // DIRTY
      // item.tip = "2"; // DIRTY
      _naziv = "NOSAC RAMA FILTERA -" + (msirinaunutrasnjaizmedjupregradnih - 2) + "x" + _izracunaj_dimenzija2(rfi_tipfiltera) + "-UNUTRASNJI PROFIL NOSACA"; //
      if (msirinaunutrasnjaizmedjupregradnih < 2500) {
        item.ter_visedelni_koliko_delova = 1; // DIRTY
        item.kolicina = kolicina * 2; // DIRTY
        item.dimenzija1 = msirinaunutrasnjaizmedjupregradnih - 2; // DIRTY
      } else {
        item.ter_visedelni_koliko_delova = 2; // DIRTY
        item.kolicina = kolicina * 4; // DIRTY
        item.dimenzija1 = ROUNDDOWN(msirinaunutrasnjaizmedjupregradnih / 2, 0); // DIRTY
      }
      item.dimenzija2 = _izracunaj_dimenzija2(rfi_tipfiltera); // DIRTY
      item.razvijenamera1 = item.dimenzija1;
      item.razvijenamera2 = _izracunaj_razvijena2(rfi_tipfiltera, tervrstaprofila_50_ili_70); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = rfi_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-15-" + _izracunaj_dimenzija2(rfi_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + (msirinaunutrasnjaizmedjupregradnih - 2) + "-P2";
      //
      item.visina = _visina_20_ili_35; // DIRTY
    }
    //
    if (family === 'terkk$rfi/UKRUCENJE_SPOLJ') { // P3.1 3. Odnosi se na ukrućenje filtera-Spoljašnji profil.
      /*
      Naziv: UKRUĆENJE RAMOVA FILTERA -" $mvisinaunutrasnjaizmedjupregradnih-5 "-SPOLJASNJI PROFIL"
      Broj komada: ROUNDDOWN($msirinaunutrasnjaizmedjupregradnih/610;0)
      Dim1: $mvisinaunutrasnjaizmedjupregradnih-5
      Dim2: 36
      Površina: Razvijena 1*Razvijena 2
      Razvijena 1: $mvisinaunutrasnjaizmedjupregradnih-5
      Razvijena 2: 69.7
      CNC crtez:
      P01-15-B-H35-1285-P3.1 (PRIMER)
      "P01-15-E-"IF(tervrstaprofila_50_ili_70=50 THEN "H20" ELSE IF(tervrstaprofila_50_ili_70=70 THEN "H35" "-"$mvisinaunutrasnjaizmedjupregradnih-5"-P3.1"
      */
      item.distinction_key = "terkk$RFI/P3_1"; // DIRTY
      // item.tip = "3"; // DIRTY
      _naziv = "UKRUĆENJE RAMOVA FILTERA -" + (msirinaunutrasnjaizmedjupregradnih - 5) + "-SPOLJASNJI PROFIL"; //
      item.kolicina = kolicina * ROUNDDOWN(msirinaunutrasnjaizmedjupregradnih / 610, 0); // DIRTY
      item.dimenzija1 = mvisinaunutrasnjaizmedjupregradnih - 5; // DIRTY
      item.dimenzija2 = 36; // DIRTY
      item.razvijenamera1 = mvisinaunutrasnjaizmedjupregradnih - 5; // DIRTY
      item.razvijenamera2 = 69.7; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = rfi_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-15-E-H" + _visina_20_ili_35 + MINUS + (mvisinaunutrasnjaizmedjupregradnih - 5) + "-P3.1";
    }
    //
    if (family === 'terkk$rfi/UKRUCENJE_UNUTR') { // P3.2 4. Odnosi se na ukrućenje filtera-unutrašnji profil.
      /*
      Naziv: UKRUĆENJE RAMOVA FILTERA -" $mvisinaunutrasnjaizmedjupregradnih-5 "-UNUTRASNJI PROFIL"
      Broj komada: ROUNDDOWN($msirinaunutrasnjaizmedjupregradnih/610;0)
      Dim1: $mvisinaunutrasnjaizmedjupregradnih-5
      Dim2: 40
      Površina: Razvijena 1*Razvijena 2
      Razvijena 1: $mvisinaunutrasnjaizmedjupregradnih-5
      Razvijena 2: 66.7
      CNC crtez:
      P01-15-E-H35-1285-P3.2 (PRIMER)
      "P01-15-E-"IF(tervrstaprofila_50_ili_70=50 THEN "H20" ELSE IF(tervrstaprofila_50_ili_70=70 THEN "H35" "-"$mvisinaunutrasnjaizmedjupregradnih-5"-P3.2"
      */
      item.distinction_key = "terkk$RFI/P3_2"; // DIRTY
      // item.tip = "4"; // DIRTY
      _naziv = "UKRUĆENJE RAMOVA FILTERA -" + (msirinaunutrasnjaizmedjupregradnih - 5) + "-UNUTRASNJI PROFIL"; //
      item.kolicina = kolicina * ROUNDDOWN(msirinaunutrasnjaizmedjupregradnih / 610, 0); // DIRTY
      item.dimenzija1 = mvisinaunutrasnjaizmedjupregradnih - 5; // DIRTY
      item.dimenzija2 = 40; // DIRTY
      item.razvijenamera1 = mvisinaunutrasnjaizmedjupregradnih - 5; // DIRTY
      item.razvijenamera2 = 66.7; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = rfi_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-15-E-H" + _visina_20_ili_35 + MINUS + (mvisinaunutrasnjaizmedjupregradnih - 5) + "-P3.2";
    }
    //
    if (family === 'terkk$rfi/SET_STEZACA') { // 5. filtera-unutrašnji profil.
      /*
      Potrebno je i za heppa filtere dodati i sledeći element:
      Naziv: SET STEZACA HEPA FILTERA
      Broj komada: 1 kom
      Dim1: 40
      Dim2: 40
      Površina: Razvijena 1*Razvijena 2
      Razvijena 1: 119
      Razvijena 2: 119
      Operacija 1: Sečenje
      Radni centar: AMADA
      Operacija 2: Savijanje
      Radni centar 2: Ermaksan
      Ident materijala: LC00000J
      Naziv materijala: LIM PROHROM 1.50
      CNC crtez:
      P01-15-100-4kom
      */
      item.distinction_key = "terkk$RFI/SET_STEZACA"; // DIRTY
      // item.tip = "5"; // DIRTY
      _naziv = "SET STEZACA HEPA FILTERA"; //
      item.kolicina = kolicina * 1; // DIRTY
      item.dimenzija1 = 40; // DIRTY
      item.dimenzija2 = 40; // DIRTY
      item.razvijenamera1 = 119; // DIRTY
      item.razvijenamera2 = 119; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = rfi_materijal_lim_deblji; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-15-100-4kom";
      //
      item.rfi_brojkomadausetustezaca = 4; // DIRTY
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_ramfiltera_izracunaj_za_step_protobomp = (state, pods_input) => {
  console.log('_derivat_terkk_ramfiltera_izracunaj_za_step_protobomp state', state);
  //
  const {
    tipkomore,
    // msirinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjukrilaca,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    vrstaprofila,
    msirinaspoljasnja,
    mvisinaspoljasnja,
  } = pods_input;
  const {
    rfi_tipfiltera,
    tervrstaprofila_50_ili_70,

    rfi_koliko_ram610x610,
    rfi_koliko_ram305x610,
    rfi_koliko_ram510x610,
    rfi_koliko_ram510x305,
    rfi_koliko_maska305x305,
    //
    rfi_materijal_lim_tanji,
    rfi_materijal_lim_deblji,
    //
    kolicina,
  } = state;
  //
  const {
    unutrasnjaIzmedjuPregradnih: msirinaunutrasnjaizmedjupregradnih, // preimenujemo  u msirinaunutrasnjaizmedjupregradnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(msirinaspoljasnja, vrstaprofila);
  const {
    unutrasnjaIzmedjuPregradnih: mvisinaunutrasnjaizmedjupregradnih, // preimenujemo  u mvisinaunutrasnjaizmedjupregradnih
    unutrasnjaIzmedjuKrilaca: mvisinaunutrasnjaizmedjukrilaca, // preimenujemo  u mvisinaunutrasnjaizmedjukrilaca
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(mvisinaspoljasnja, vrstaprofila);
  //
  // TODO
  const protobomp_superdata = {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
    tervrstaprofila_50_ili_70,
    rfi_tipfiltera,
    //
    rfi_materijal_lim_tanji,
    rfi_materijal_lim_deblji,
    //
    kolicina,
  };
  //

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$rfi"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_ramfiltera_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  // NJ: Ovde nemamo sklop za elemente. Svaki element ide zasebno kao i materijal.
  /*
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$rfi/SKLOP_RFI',
    naziv: '* SKLOP RFI',
    kolicina: kolicina,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_RFI');
  const { created_tempkey: sklop_rfi } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  */
  // NJ: Ovde nemamo sklop za elemente. Svaki element ide zasebno kao i materijal.
  const sklop_rfi = null; // VAZNO laziramo da elementima parent bude protobomp root (null) umesto sklop
  //
  // ----- dodavanje primitivnih u sklopove
  //
  if (true) {
    //
    // 1. P1
    if (true) { // P1 1. odnosi se na spoljašnji profil nosača filtera.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$rfi/NOSAC_SPOLJ',
        identmaterijala: rfi_materijal_lim_tanji,
        naziv: '* NOSAC RAMA FILTERA',
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    // 2. P2
    if (true) { // P2 2. Odnosi se na unutrašnji profil nosača filtera.
      const item = {
        tempkey: 2,
        pbnode_family: 'terkk$rfi/NOSAC_UNUTR',
        identmaterijala: rfi_materijal_lim_deblji,
        naziv: '* NOSAC RAMA FILTERA',
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    // 3. // P3.1
    if (true) { // P3.1 3. Odnosi se na ukrućenje filtera-Spoljašnji profil.
      const item = {
        tempkey: 3,
        pbnode_family: 'terkk$rfi/UKRUCENJE_SPOLJ',
        identmaterijala: rfi_materijal_lim_deblji,
        naziv: '* UKRUĆENJE RAMOVA FILTERA',
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    // 4. // P3.2
    if (true) { // P3.2 4. Odnosi se na ukrućenje filtera-unutrašnji profil.
      const item = {
        tempkey: 4,
        pbnode_family: 'terkk$rfi/UKRUCENJE_UNUTR',
        identmaterijala: rfi_materijal_lim_deblji,
        naziv: '* UKRUĆENJE RAMOVA FILTERA',
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    // 5. // ***P3.2
    if (rfi_tipfiltera === "HEPA_25" || rfi_tipfiltera === "HEPA_292") { // Potrebno je i za heppa filtere dodati i sledeći element
      const item = {
        tempkey: 4,
        pbnode_family: 'terkk$rfi/SET_STEZACA',
        identmaterijala: rfi_materijal_lim_deblji,
        naziv: '* SET STEZACA HEPA FILTERA',
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    //
    // ------ dodavanje direktnih materijala
    /*
    rfi_koliko_ram610x610,
    rfi_koliko_ram305x610,
    rfi_koliko_ram510x610,
    rfi_koliko_ram510x305,
    rfi_koliko_maska305x305,
    */
    // * rfi_koliko_ram610x610
    if (rfi_koliko_ram610x610 > 0) {
      const _ter_filter = _novo_tabela_za_ramfiltera_get_item(tipkomore, rfi_tipfiltera, '610x610', null, 'MASKA', null);
      const item = {
        tempkey: 140,
        naziv: _ter_filter.naziv,
        // pbnode_family: 'terkk$rfi/?',
        kolicina: kolicina * rfi_koliko_ram610x610, //
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: _ter_filter.identcustom,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    // * rfi_koliko_ram305x610
    if (rfi_koliko_ram305x610 > 0) {
      const _ter_filter = _novo_tabela_za_ramfiltera_get_item(tipkomore, rfi_tipfiltera, '305x610', null, 'MASKA', null);
      const item = {
        tempkey: 140,
        naziv: _ter_filter.naziv,
        // pbnode_family: 'terkk$rfi/?',
        kolicina: kolicina * rfi_koliko_ram305x610, //
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: _ter_filter.identcustom,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    // * rfi_koliko_ram510x610
    if (rfi_koliko_ram510x610 > 0) {
      const _ter_filter = _novo_tabela_za_ramfiltera_get_item(tipkomore, rfi_tipfiltera, '510x610', null, 'MASKA', null);
      const item = {
        tempkey: 140,
        naziv: _ter_filter.naziv,
        // pbnode_family: 'terkk$rfi/?',
        kolicina: kolicina * rfi_koliko_ram510x610, //
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: _ter_filter.identcustom,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    // * rfi_koliko_ram510x305
    if (rfi_koliko_ram510x305 > 0) {
      const _ter_filter = _novo_tabela_za_ramfiltera_get_item(tipkomore, rfi_tipfiltera, '510x305', null, 'MASKA', null);
      const item = {
        tempkey: 140,
        naziv: _ter_filter.naziv,
        // pbnode_family: 'terkk$rfi/?',
        kolicina: kolicina * rfi_koliko_ram510x305, //
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: _ter_filter.identcustom,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    // * rfi_koliko_maska305x305
    if (rfi_koliko_maska305x305 > 0) {
      const _ter_filter = _novo_tabela_za_ramfiltera_get_item(tipkomore, rfi_tipfiltera, 'MASKA', null, null, null);
      const item = {
        tempkey: 140,
        naziv: _ter_filter.naziv,
        // pbnode_family: 'terkk$rfi/?',
        kolicina: kolicina * rfi_koliko_maska305x305, //
        jm: tclocal.JM_KOM,
        identcustom: _ter_filter.identcustom,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    //
    const _rfi_koliko_ramova_ukupno = (rfi_koliko_ram610x610 + rfi_koliko_ram305x610 + rfi_koliko_ram510x610 + rfi_koliko_ram510x305);
    //
    if (rfi_tipfiltera === "VRECASTI_25" || rfi_tipfiltera === "PANELNI_45" || rfi_tipfiltera === "DUPLI_24_45") {
      const item = {
        tempkey: 140,
        naziv: "FILTERI OPREMA ZICANA KOPCA PROHROM FI 2mm",
        // pbnode_family: 'terkk$rfi/?',
        kolicina: (kolicina * _rfi_koliko_ramova_ukupno * 4), // Količine 4 po svakom ramu filtera.
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: "B000100000000025",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
    }
    //
    if (rfi_tipfiltera === "HEPA_25" || rfi_tipfiltera === "HEPA_292") {
      //
      if (true) {
        const item = {
          tempkey: 140,
          naziv: "NAVOJNO VRETENO - INOX PROHROM M8X40mm",
          // pbnode_family: 'terkk$rfi/?',
          kolicina: (kolicina * _rfi_koliko_ramova_ukupno * 4), // Količine 4 po svakom ramu filtera.
          jm: tclocal.JM_KOM,
          terkategorija: "M",
          identcustom: "D000000000000151",
        };
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
      }
      //
      if (true) {
        const item = {
          tempkey: 140,
          naziv: "STOPA PLASTIKA FI 15",
          // pbnode_family: 'terkk$rfi/?',
          kolicina: (kolicina * _rfi_koliko_ramova_ukupno * 4), // Količine 4 po svakom ramu filtera.
          jm: tclocal.JM_KOM,
          terkategorija: "M",
          identcustom: "D000000000000155",
        };
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
      }
    }
    // zaptivna traka arosio
    if (true) {
      const item = {
        tempkey: 140,
        naziv: "TRAKA ZAPTIVNA AROSIO 20X4",
        // pbnode_family: 'terkk$ramfuk/?',
        // kolicina: kolicina *, //
        kolicina: 0, //
        jm: tclocal.JM_M,
        terkategorija: "M",
        identcustom: "A040000000000009",
      };
      let _rfi_zaptivna_traka_kolicina = 0;
      _rfi_zaptivna_traka_kolicina += (kolicina * rfi_koliko_ram610x610 * 2.5); // 610x610-2.5m
      _rfi_zaptivna_traka_kolicina += (kolicina * rfi_koliko_ram305x610 * 1.9); // 305x610-1.9m
      _rfi_zaptivna_traka_kolicina += (kolicina * rfi_koliko_ram510x610 * 2.3); // 510x610-2.3m
      _rfi_zaptivna_traka_kolicina += (kolicina * rfi_koliko_ram510x305 * 1.7); // 305x510-1.7m
      _rfi_zaptivna_traka_kolicina += (kolicina * rfi_koliko_maska305x305 * 1.3); // Količina zaptivne trake za maske je 1.3m,
      item.kolicina = ROUNDUP(_rfi_zaptivna_traka_kolicina, 3);
      if (item.kolicina > 0) {
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_rfi);
      }
    }
    //

  }

  //
  //
  return {
    svasta: {
    },
    // _arr,
    _protobomp,
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_ramfiltera_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_ramfiltera_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_ramfiltera_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

